import type { Example } from "../types";
import code from "./code.js" with { type: "text" };
import golden from "./golden.json";

export const magecartSkimmer: Example = {
  id: "magecart-skimmer",
  title: "Checkout form skimmer",
  group: "incident",
  environment: "browser",
  mode: "script",
  summary: "Keylogs the checkout form and beacons the card to a look-alike domain",
  explainer:
    "Modeled on Magecart-style payment skimmers. Its strings are hex-escaped and its exfil host is base64 (`atob`), so nothing in the source names the destination. It polls for `#checkout`, adds an `input` listener to every field and a `submit` listener to the form. This example turns on **simulated user activity**: after load the simulated shopper types the run's canaries (a Luhn-valid card number, expiry, CVC, name, and email) and pays. Watch the DOM listener registrations, the RUN `user.type` rows, the form-field reads, and finally a NET image load to cdn.sh0p.example whose URL carries the base64 JSON of everything typed. The canary badge and the Report's critical form-exfiltration findings show the card, name, and email leaving the page.",
  code,
  context: { activity: { fill: true, submit: true } },
  expect: golden as Example["expect"],
};
